module.exports = __webpack_public_path__ + "img/20191118160449408.7c15af76.jpg";